/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CmsCourseDto,
  CmsCourseLessonDto,
  CmsCourseLessonUpdateRequest,
  CmsCourseUpdateRequest
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType , BodyType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **ROLE_USER, ROLE_INTERNAL_USER**<br /><br />
 */
export const getCmsCourseMetaById = (
    userId: string,
    courseId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CmsCourseDto>(
      {url: `/api/${userId}/cms-meta/courses/${courseId}`, method: 'GET', signal
    },
      options);
    }




export const getGetCmsCourseMetaByIdQueryKey = (userId: string,
    courseId: number,) => {
    return [
    `/api/${userId}/cms-meta/courses/${courseId}`
    ] as const;
    }


export const getGetCmsCourseMetaByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError = ErrorType<unknown>>(userId: string,
    courseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCmsCourseMetaByIdQueryKey(userId,courseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCmsCourseMetaById>>> = ({ signal }) => getCmsCourseMetaById(userId,courseId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && courseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCmsCourseMetaByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCmsCourseMetaById>>>
export type GetCmsCourseMetaByIdQueryError = ErrorType<unknown>


export function useGetCmsCourseMetaById<TData = Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError = ErrorType<unknown>>(
 userId: string,
    courseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsCourseMetaById>>,
          TError,
          Awaited<ReturnType<typeof getCmsCourseMetaById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsCourseMetaById<TData = Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError = ErrorType<unknown>>(
 userId: string,
    courseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsCourseMetaById>>,
          TError,
          Awaited<ReturnType<typeof getCmsCourseMetaById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsCourseMetaById<TData = Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError = ErrorType<unknown>>(
 userId: string,
    courseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCmsCourseMetaById<TData = Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError = ErrorType<unknown>>(
 userId: string,
    courseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCourseMetaById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCmsCourseMetaByIdQueryOptions(userId,courseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **ROLE_USER, ROLE_INTERNAL_USER**<br /><br />
 */
export const updateCmsCourseMeta = (
    userId: string,
    courseId: number,
    cmsCourseUpdateRequest: BodyType<CmsCourseUpdateRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CmsCourseDto>(
      {url: `/api/${userId}/cms-meta/courses/${courseId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cmsCourseUpdateRequest, signal
    },
      options);
    }



export const getUpdateCmsCourseMetaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCmsCourseMeta>>, TError,{userId: string;courseId: number;data: BodyType<CmsCourseUpdateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCmsCourseMeta>>, TError,{userId: string;courseId: number;data: BodyType<CmsCourseUpdateRequest>}, TContext> => {

const mutationKey = ['updateCmsCourseMeta'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCmsCourseMeta>>, {userId: string;courseId: number;data: BodyType<CmsCourseUpdateRequest>}> = (props) => {
          const {userId,courseId,data} = props ?? {};

          return  updateCmsCourseMeta(userId,courseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCmsCourseMetaMutationResult = NonNullable<Awaited<ReturnType<typeof updateCmsCourseMeta>>>
    export type UpdateCmsCourseMetaMutationBody = BodyType<CmsCourseUpdateRequest>
    export type UpdateCmsCourseMetaMutationError = ErrorType<unknown>

    export const useUpdateCmsCourseMeta = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCmsCourseMeta>>, TError,{userId: string;courseId: number;data: BodyType<CmsCourseUpdateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCmsCourseMeta>>,
        TError,
        {userId: string;courseId: number;data: BodyType<CmsCourseUpdateRequest>},
        TContext
      > => {
      return useMutation(getUpdateCmsCourseMetaMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **ROLE_USER, ROLE_INTERNAL_USER**<br /><br />
 */
export const deleteCmsCourseMeta = (
    userId: string,
    courseId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/${userId}/cms-meta/courses/${courseId}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteCmsCourseMetaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCmsCourseMeta>>, TError,{userId: string;courseId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCmsCourseMeta>>, TError,{userId: string;courseId: number}, TContext> => {

const mutationKey = ['deleteCmsCourseMeta'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCmsCourseMeta>>, {userId: string;courseId: number}> = (props) => {
          const {userId,courseId} = props ?? {};

          return  deleteCmsCourseMeta(userId,courseId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCmsCourseMetaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCmsCourseMeta>>>

    export type DeleteCmsCourseMetaMutationError = ErrorType<unknown>

    export const useDeleteCmsCourseMeta = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCmsCourseMeta>>, TError,{userId: string;courseId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCmsCourseMeta>>,
        TError,
        {userId: string;courseId: number},
        TContext
      > => {
      return useMutation(getDeleteCmsCourseMetaMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **ROLE_USER, ROLE_INTERNAL_USER**<br /><br />
 */
export const updateCmsCourseLessonMeta = (
    userId: string,
    courseId: number,
    lessonId: number,
    cmsCourseLessonUpdateRequest: BodyType<CmsCourseLessonUpdateRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CmsCourseLessonDto>(
      {url: `/api/${userId}/cms-meta/courses/${courseId}/lessons/${lessonId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cmsCourseLessonUpdateRequest, signal
    },
      options);
    }



export const getUpdateCmsCourseLessonMetaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCmsCourseLessonMeta>>, TError,{userId: string;courseId: number;lessonId: number;data: BodyType<CmsCourseLessonUpdateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCmsCourseLessonMeta>>, TError,{userId: string;courseId: number;lessonId: number;data: BodyType<CmsCourseLessonUpdateRequest>}, TContext> => {

const mutationKey = ['updateCmsCourseLessonMeta'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCmsCourseLessonMeta>>, {userId: string;courseId: number;lessonId: number;data: BodyType<CmsCourseLessonUpdateRequest>}> = (props) => {
          const {userId,courseId,lessonId,data} = props ?? {};

          return  updateCmsCourseLessonMeta(userId,courseId,lessonId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCmsCourseLessonMetaMutationResult = NonNullable<Awaited<ReturnType<typeof updateCmsCourseLessonMeta>>>
    export type UpdateCmsCourseLessonMetaMutationBody = BodyType<CmsCourseLessonUpdateRequest>
    export type UpdateCmsCourseLessonMetaMutationError = ErrorType<unknown>

    export const useUpdateCmsCourseLessonMeta = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCmsCourseLessonMeta>>, TError,{userId: string;courseId: number;lessonId: number;data: BodyType<CmsCourseLessonUpdateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCmsCourseLessonMeta>>,
        TError,
        {userId: string;courseId: number;lessonId: number;data: BodyType<CmsCourseLessonUpdateRequest>},
        TContext
      > => {
      return useMutation(getUpdateCmsCourseLessonMetaMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **ROLE_USER, ROLE_INTERNAL_USER**<br /><br />
 */
export const getCmsCoursesMeta = (
    userId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CmsCourseDto[]>(
      {url: `/api/${userId}/cms-meta/courses`, method: 'GET', signal
    },
      options);
    }




export const getGetCmsCoursesMetaQueryKey = (userId: string,) => {
    return [
    `/api/${userId}/cms-meta/courses`
    ] as const;
    }


export const getGetCmsCoursesMetaQueryOptions = <TData = Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError = ErrorType<unknown>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCmsCoursesMetaQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCmsCoursesMeta>>> = ({ signal }) => getCmsCoursesMeta(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCmsCoursesMetaQueryResult = NonNullable<Awaited<ReturnType<typeof getCmsCoursesMeta>>>
export type GetCmsCoursesMetaQueryError = ErrorType<unknown>


export function useGetCmsCoursesMeta<TData = Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError = ErrorType<unknown>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsCoursesMeta>>,
          TError,
          Awaited<ReturnType<typeof getCmsCoursesMeta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsCoursesMeta<TData = Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsCoursesMeta>>,
          TError,
          Awaited<ReturnType<typeof getCmsCoursesMeta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsCoursesMeta<TData = Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCmsCoursesMeta<TData = Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsCoursesMeta>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCmsCoursesMetaQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






